import styled from 'styled-components';
import {
  ICON_CHAT,
  ICON_CS,
  IMG_LOGIN_LINE,
  IMG_LOGIN_WECHAT,
  IMG_QR_WECHAT,
} from '@repo/assets';
import { Button, Icon } from '@successmode-ktp/kui';
import { FaqToggle } from './FaqToggle';
import { ReactNode, useState } from 'react';
import { FAQ } from '@repo/constants';

type Faq = {
  title: string;
  contents: ReactNode;
};

type Props = {
  faqList: Faq[];
  onBackPage: () => void;
  onInquiry: () => void;
  lang?: 'KOR' | 'ENG';
};

export const Faq = ({
  faqList,
  onBackPage,
  onInquiry,
  lang = 'ENG',
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <TitleWrapper>
        <button type='button' onClick={onBackPage}>
          <Icon.ChevronLeft fillColor='#A7A7A7' />
        </button>
        <Title>
          <IconCs src={ICON_CS} alt='' />
          {FAQ[lang].title}
        </Title>
        <Box />
      </TitleWrapper>
      <DivideLine />
      {isOpen && (
        <WechatWrapper>
          <WechatQrImg src={IMG_QR_WECHAT} alt='' />
        </WechatWrapper>
      )}
      {!isOpen && (
        <FaqWrapper>
          {faqList.map((faq) => {
            return <FaqToggle key={faq.title} {...faq} />;
          })}
        </FaqWrapper>
      )}
      <InquiryWrapper>
        <ExplainText>{FAQ[lang].contents}</ExplainText>
        <Button type='button' style={{ gap: '8px' }} onClick={onInquiry}>
          <img src={ICON_CHAT} alt='' width={24} height={24} />
          {FAQ[lang].btnText}
        </Button>
        <SNSWrapper>
          <button type='button' onClick={() => setIsOpen(!isOpen)}>
            <img src={IMG_LOGIN_WECHAT} alt='' width={40} height={40} />
          </button>
          <a href='https://line.me/ti/p/2vjo-TwDTX' target='_blank'>
            <img src={IMG_LOGIN_LINE} alt='' width={40} height={40} />
          </a>
        </SNSWrapper>
      </InquiryWrapper>
    </>
  );
};

const TitleWrapper = styled.h6`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 20px;
  width: 100%;
  background-color: #fff;
`;

const Box = styled.div`
  width: 24px;
  height: 24px;
`;

const Title = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #030303;
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.4px;
`;

const IconCs = styled.img`
  display: block;
  width: 24px;
  height: 24px;
`;

const DivideLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f4f4f4;
`;

const FaqWrapper = styled.div`
  height: 100%;
  overflow: auto;
  padding-bottom: 210px;
`;

const InquiryWrapper = styled.div`
  position: fixed;
  bottom: 0;
  padding: 20px;
  width: 100%;
  border-top: 1px solid #f4f4f4;
  background-color: #fff;
  overflow: auto;
`;

const ExplainText = styled.small`
  display: block;
  color: var(--KTP-Grayscale-Gray_05, #777);
  text-align: center;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.28px;
  padding-bottom: 20px;
`;

const SNSWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding-top: 20px;
`;

const WechatWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const WechatQrImg = styled.img`
  display: block;
  width: 90%;
`;
